var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "All-kinds"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Star_1397644-_1_",
    "data-name": "noun_Star_1397644-(1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M18.32,22a.86.86,0,0,1-.41-.1L12.5,19,7.09,21.9a.87.87,0,0,1-1.27-.74L5.6,15,.41,11.74a.87.87,0,0,1,0-1.48L5.6,7,5.82.84A.87.87,0,0,1,7.09.1L12.5,3,17.91.1a.87.87,0,0,1,1.27.74L19.4,7l5.19,3.26a.87.87,0,0,1,0,1.48L19.4,15l-.22,6.16a.86.86,0,0,1-.43.72A.82.82,0,0,1,18.32,22ZM12.5,17.14a1,1,0,0,1,.41.1L17.5,19.7l.18-5.22a.87.87,0,0,1,.4-.71L22.49,11,18.08,8.23a.87.87,0,0,1-.4-.71L17.5,2.3,12.91,4.76a.91.91,0,0,1-.82,0L7.5,2.3,7.32,7.52a.87.87,0,0,1-.4.71L2.51,11l4.41,2.77a.87.87,0,0,1,.4.71L7.5,19.7l4.59-2.46A1,1,0,0,1,12.5,17.14Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToday);
export default __webpack_public_path__ + "static/media/today.39f69f2933c46da3724c9fa5cb3aa3d1.svg";
export { ForwardRef as ReactComponent };